import React, { Component } from 'react';
import { observer } from 'mobx-react';
import { withStyles } from 'material-ui/styles';

import withAppStore from 'decorators/withAppStore';
import styles from 'styles/components/CodeInfoSection';
import ToDateNotificator from 'components/ToDateNotificator';
import { formatOrder } from 'components/CodeInfo';
import CodeInfoSection from 'components/CodeInfoSection';

@withStyles(styles)
@withAppStore
@observer
export default class CodeInfoExciseDutyMarks extends Component {

    render() {
        const { exciseDutyMarks } = this.props;
        const summary = getTitleSummary(exciseDutyMarks)
        return (
            <CodeInfoSection
                title={{
                    headers: ['Товар, подлежит маркировке акцизными (специальными) марками'],
                    rows: summary
                }}
                expanded={(exciseDutyMarks.length !== 0) ? true : false}
                table={{
                    headers: [
                        '',
                        'Описание',
                        'Нормативный документ'
                    ],
                    rows: exciseDutyMarks.map(({ to_date = null, description = '', order, order_date, orders_info = null }) => ([
                        <ToDateNotificator to_date={to_date} />,
                        description,
                        formatOrder(order, order_date, orders_info)
                    ]))
                }}
            />);
    }
}

function getTitleSummary(items) {
    return items.length !== 0 ? [['есть']] : null;
}





// WEBPACK FOOTER //
// ./src/components/codeinfo/CodeInfoExciseDutyMarks.js